import React from 'react';
import { SummaryBlock } from '../common/SummaryBlock';
import { CheckoutSiteInfo } from './CheckoutSiteInfo';

export const CheckedOutSummary = () => {
    return (
        <>
            <SummaryBlock display className='body-text body-text-pl mb-1'>
                Summary of site visit
            </SummaryBlock>
            <CheckoutSiteInfo />
        </>
    );
}
